module.exports = __webpack_public_path__ + "img/write.38a533fb.png";